import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import OTP from './OTP';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading,
    error,
    message,
    resendOtpSuccess,
    otpVerified,
  } = state.auth;
  return {
    isLoading,
    error,
    message,
    resendOtpSuccess,
    otpVerified,
  };
}

const Styled = withStyles(styles)(OTP);

export default connect(
  mapStateToProps,
)(Styled);
